import {
  canManageVenueUsers,
  lookupAccountVenueRole,
} from 'src/utils/venueRoleCapabilities'

const ownerId = venue => {
  if (!venue?.account) return ''
  if (venue.account._id) return String(venue.account._id)
  return String(venue.account)
}

/** Same people who can change categories on the server. Day entry is separate. */
export const canConfigureRevenueCategories = ({ account, venue } = {}) => {
  if (!account || !venue) return false
  if (account.isAdmin === true) return true
  if (
    (account.TFRAdmin && venue.TFRVenue) ||
    (account.GREENAdmin && venue.GREENVenue) ||
    (account.JUSTAdmin && venue.JUSTVenue)
  ) {
    return true
  }
  if (ownerId(venue) && ownerId(venue) === String(account._id)) return true
  return canManageVenueUsers(lookupAccountVenueRole(account, venue._id))
}
